import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import React from "react";

import { CoverageOption, SelectedCoverage } from "../types";

import { ICoverageQuestionnaireItem, IPlanName } from "./constants";

export interface ICensusExistingCoverageQuestionnaire {
  coverageName: string;
  options: ICoverageQuestionnaireItem[];
  onChangeOptions?: (
    coverage: string,
    name: string,
    value: string | { value?: string } | CoverageOption,
  ) => void;
  selectedCoverages: SelectedCoverage;
}

const CensusExistingCoverageQuestionnaire = (
  props: ICensusExistingCoverageQuestionnaire,
) => {
  const { coverageName, options, onChangeOptions, selectedCoverages } = props;
  const selectedValue =
    selectedCoverages[coverageName]?.coverageOption?.value ?? "";

  return (
    <FormControl>
      <FormLabel required>
        {" "}
        Please select which {coverageName} options are offered:
      </FormLabel>
      <RadioGroup
        value={selectedValue}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          onChangeOptions?.(coverageName, "coverageOption", {
            value: e.target.value,
          });
        }}
      >
        {options.map((item) => (
          <div key={item.value}>
            <FormControlLabel
              key={item.value}
              value={item.value}
              control={<Radio />}
              label={item.label}
            />
            {selectedValue === item.value && item.planNames && (
              <Box pl={4}>
                <FormLabel required>
                  Please provide a Plan Name for each Plan below—
                </FormLabel>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell align="left" sx={{ fontWeight: 600 }}>
                        Plan
                      </TableCell>
                      <TableCell align="left" sx={{ fontWeight: 600 }}>
                        Plan Name
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {item.planNames.map((plan: IPlanName, index: number) => {
                      const coverageOption =
                        selectedCoverages[coverageName]?.coverageOption;
                      const existingPlans = coverageOption!.plans ?? {};
                      const value = existingPlans[plan.value] ?? "";
                      return (
                        <TableRow key={index}>
                          <TableCell align="left">{plan.label}</TableCell>
                          <TableCell align="left">
                            <TextField
                              name="row"
                              sx={{ marginTop: 1, width: "40vw" }}
                              variant="outlined"
                              label="Add the plan name found in this census"
                              value={value}
                              required
                              onChange={(
                                e: React.ChangeEvent<HTMLInputElement>,
                              ) => {
                                onChangeOptions?.(
                                  coverageName,
                                  `coverageOption`,
                                  {
                                    ...coverageOption,
                                    plans: {
                                      ...existingPlans,
                                      [plan.value]: e.target.value,
                                    },
                                  },
                                );
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </Box>
            )}
          </div>
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default CensusExistingCoverageQuestionnaire;
